<template>
  <div>
    <div @click="visible = true">
      <slot />
    </div>

    <a-modal title="选择固定资产" :visible="visible" @cancel="cancel" :footer="null" width="1500px">
      <a-input-search style="margin-bottom: 16px" placeholder="请输入资产编码进行查询" enter-button v-model="search"
        @search="onSearch"></a-input-search>

      <a-table :indentSize="0" bordered :data-source="list" :loading="loading" @change="onChange"
        :rowClassName="() => 'clickable'" :pagination="{
                          total,
                          current,
                          pageSize,
                          showTotal: (total) => `共 ${total} 条记录`,
                        }" :customRow="
                                  (record) => {
                                    return {
                                      on: {
                                        click: () => {
                                          onTableRowClick(record);
                                        },
                                      },
                                    };
                                  }
                                "
                                rowKey='id'
                                >
        <a-table-column title="资产编码" data-index="assetCode"> </a-table-column>
        <a-table-column title="资产类别">
          <template slot-scope="text">
            <div style="display: flex;align-items: center">
              <DataDictFinder
              dictType="fixed_asset_type"
              :dictValue="text.category.categoryCode"
            />-
            {{text.category.subCategoryName}}
            </div>
          </template>
        </a-table-column>
        <a-table-column title="品牌型号" data-index="brandModel"> </a-table-column>
        <a-table-column title="采购日期" data-index="procurementTime"> </a-table-column>
        <a-table-column title="采购价格(元)" data-index="purchasePrice"> </a-table-column>
        <a-table-column title="资产负责人" data-index="responsiblePersonName"> </a-table-column>
        <a-table-column title="资产位置(部门)" data-index="deptName"> </a-table-column>
        <a-table-column title="财务编码" data-index="financialCode"> </a-table-column>
        <a-table-column title="启用日期" data-index="startTime"> </a-table-column>
        <a-table-column title="资产状态">
          <template slot-scope="text">
            <DataDictFinder
              dictType="fixed_asset_status"
              :dictValue="text.status"
              iconType="badge"
            />
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import request from "@/api/request";
function fetchList(data) {
  return request({
    url: "/office-service/fixed-asset/page",
    data,
    method: 'post'
  });
}
export default {
  data() {
    return {
      visible: false,
      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
      search: "",
    };
  },



  watch: {
    visible(newValue) {
      if (newValue) {
        if (this.list.length === 0) {
          this.getList();
        }
      }
    },
  },

  methods: {

    getList() {
     const { current, pageSize, form } = this;

    this.loading = true;   
     fetchList({
        pageNum: current,
        pageSize,
        assetCode: this.search,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },

    onSearch() {
      this.current = 1;
      this.getList();
    },

    onTableRowClick(record) {
      this.$emit("change", record);
      this.visible = false;
    },

    cancel() {
      this.visible = false;
      this.$emit("cancel");
    },
  },
};
</script>